<script>
import { authMethods, authComputed } from '@state/helpers'
import appConfig from '@src/app.config'
import { BASE_PATH } from '@utils/constant'
import { removeScript } from '@utils/loadScript'

export default {
  page() {
    return {
      title: this.$t('pages.login'),
      meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
    }
  },
  data() {
    return {
      adminName: '',
      password: '',
      showPassword: false,
      openForgotPasswordModal: false,
      errors: null,
    }
  },
  computed: {
    ...authComputed,
    loginError() {
      return this.getError
    },
    getForgotComputed() {
      return this.getForgot?.email
    },
  },
  created() {
    this.reCaptchaKeys()
  },
  beforeDestroy() {
    removeScript(process.env.VUE_APP_GOOGLE_RECAPTCHA_BASE_URL)
    const captchaBadge = document.getElementsByClassName('grecaptcha-badge')
    if (captchaBadge && captchaBadge[0]) {
      captchaBadge[0].remove()
    }
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the admin name
    // and password they provided.
    async tryToLogIn() {
      if (this.password && this.adminName) {
        this.errors = null
        const { agent_code: value } = this.$route.query
        const reCaptchaEnabled = this.captcha?.enable
        let captchaToken = ''
        if (reCaptchaEnabled) {
          captchaToken = await this.validateCaptcha()
        }
        const user = await this.logIn({
          adminName: this.adminName,
          password: this.password,
          agentCode: value,
          ...(reCaptchaEnabled && { captchaToken }),
        })
        if (user) {
          this.$router.push({ name: BASE_PATH[user.level] })
        }
      } else {
        this.errors = 'マネージャIDまたはパスワードが未入力です。'
      }
    },
    validateCaptcha() {
      const siteKey = this.captcha?.site_key
      return new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(siteKey, { action: 'submit' })
            .then((token) => {
              return resolve(token)
            })
        })
      })
    },
    showForgotPasswordModal() {
      this.fetchForgot()
      this.openForgotPasswordModal = !this.openForgotPasswordModal
    },
    fetchForgot() {
      const payload = {
        agent_code: this.$route.query.agent_code,
      }
      this.fetchingForgot(payload)
    },
  },
}
</script>

<template>
  <CWrapper id="feelline-login-page">
    <div class="c-app align-items-center c-app-override">
      <CContainer>
        <CRow class="justify-content-center">
          <CCol md="5">
            <CCardGroup>
              <CCard class="p-4">
                <CCardBody>
                  <validation-observer ref="observer" v-slot="{ handleSubmit }">
                    <CForm
                      id="feeline-login-form"
                      ref="form"
                      @submit.stop.prevent="handleSubmit(tryToLogIn)"
                    >
                      <div class="d-flex justify-content-center my-4">
                        <CImg :src="require('@assets/images/FEELLINE.png')" />
                      </div>
                      <CAlert color="danger" :show="loginError && !errors">{{
                        loginError
                      }}</CAlert>
                      <CAlert color="danger" :show="!!errors">{{
                        errors
                      }}</CAlert>
                      <BaseInput
                        v-model="adminName"
                        vee-name="adminName"
                        :placeholder="$t('fields.adminName')"
                      >
                        <template v-slot:prepend-content
                          ><CIcon name="cil-user"
                        /></template>
                      </BaseInput>
                      <BaseInput
                        v-model="password"
                        vee-name="password"
                        :placeholder="$t('fields.password')"
                        :adornment="showPassword ? 'eye' : 'eye-slash'"
                        :type="showPassword ? 'text' : 'password'"
                        @clickAdornment="showPassword = !showPassword"
                      >
                        <template v-slot:prepend-content
                          ><CIcon name="cil-lock-locked"
                        /></template>
                      </BaseInput>
                      <div class="d-flex justify-content-end">
                        <CButton
                          type="submit"
                          variant="outline"
                          color="dark"
                          class="px-4"
                          >{{ $t('common.login') }}</CButton
                        >
                      </div>
                      <div class="d-flex justify-content-end">
                        <CLink
                          class="px-0 mt-2"
                          @click="showForgotPasswordModal"
                          >パスワードを忘れましたか?</CLink
                        >
                      </div>
                    </CForm>
                  </validation-observer>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
    <BaseFooter />
    <BaseModalConfirm
      type="forget_password"
      backdrop-close
      :show.sync="openForgotPasswordModal"
      @closeModal="openForgotPasswordModal = !openForgotPasswordModal"
    >
      <template v-slot>
        ＜管理者の方＞
        <br />
        support@feelline.jp にお問い合わせください。
        <br />
        <br />
        ＜その他＞
        <br />
        {{ getForgotComputed }} にお問い合わせください。
      </template>
    </BaseModalConfirm>
  </CWrapper>
</template>

<style lang="scss" scoped>
#feelline-login-page {
  .c-app-override {
    min-height: calc(100vh - 50px);
  }
}
</style>
